/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2019-09-18 14:28:28
 * Copyright © Leedarson. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import useInterval from './useInterval';

// 时间格式化
const formatTimer = (time: number, format: string) => {
  let finalTime = format;
  const hour = parseInt(`${time / 3600}`, 10);
  const minute = parseInt(`${(time - hour * 3600) / 60}`, 10);
  const second = time - hour * 3600 - minute * 60;

  const object: { [key: string]: number } = {
    'h+': hour,
    'm+': minute,
    's+': second,
  };

  if (format === '') {
    return time;
  }

  Object.keys(object).forEach((key) => {
    if (new RegExp(`(${key})`).test(finalTime)) {
      const val =
        RegExp.$1.length === 1
          ? object[key]
          : `00${object[key]}`.substr(`${object[key]}`.length);
      finalTime = finalTime.replace(RegExp.$1, val as string);
    }
  });

  return finalTime;
};

interface TimerProps {
  type: 'countdown' | 'timer';
  format: string;
  countdown: number;
  stop?: boolean;
  render: any;
  onEnd: () => void;
}

const Timer = ({
  type,
  countdown,
  format,
  stop,
  render,
  onEnd,
}: TimerProps) => {
  const [remain, setRemain] = useState(countdown);

  useEffect(() => {
    if (countdown) {
      setRemain(countdown);
    }
  }, [countdown]);

  // 倒计时
  useInterval(
    () => {
      if (type === 'countdown') {
        if (remain <= 0) {
          return;
        }
        // 递减
        setRemain((time) => time - 1);

        if (remain <= 1) {
          onEnd();
        }
      } else {
        if (remain >= countdown) {
          return;
        }
        // 递增
        setRemain((time) => time + 1);
        if (remain >= countdown) {
          onEnd();
        }
      }
    },
    stop ? 0 : 1000,
  );

  return <>{render(formatTimer(remain, format), remain)}</>;
};

export default Timer;
